import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { useSettings } from "@/hooks/useContent";
import { isReal } from "@/lib/display";

export function Footer() {
  const { data: s } = useSettings();
  const year = new Date().getFullYear();

  const quick = [
    ["Ana Sayfa", "/"], ["Kurumsal", "/kurumsal"], ["Hizmetler", "/hizmetler"],
    ["Projeler", "/projeler"], ["İletişim", "/iletisim"],
  ];
  const services = [
    ["Endüstriyel Elektrik", "/hizmetler/endustriyel-elektrik"],
    ["Otomasyon", "/hizmetler/endustriyel-otomasyon"],
    ["Elektrik Taahhüt", "/hizmetler/elektrik-taahhut"],
    ["Pano Sistemleri", "/hizmetler/pano-sistemleri"],
    ["Projelendirme", "/hizmetler/projelendirme-muhendislik"],
  ];

  return (
    <footer data-testid="footer" className="relative bg-dark text-silver overflow-hidden">
      <div className="grid-lines-dark absolute inset-0 opacity-40" />
      <div
        aria-hidden
        className="pointer-events-none select-none absolute -bottom-10 right-0 font-head font-extrabold text-white/[0.03] text-[26vw] leading-none"
      >
        SEM
      </div>

      <div className="relative mx-auto max-w-[1400px] px-5 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-4">
            <img src="/sem-logo-white.png" alt="Sistem Elektrik ve Mühendislik" className="h-16 w-auto" />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-silver/70">
              Elektrik, otomasyon ve mühendislik projelerinde keşiften devreye almaya kadar
              güvenilir ve sürdürülebilir çözümler.
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-white font-head font-semibold text-sm tracking-wide mb-5">Hızlı Erişim</h4>
            <ul className="space-y-3">
              {quick.map(([l, to]) => (
                <li key={to}>
                  <Link to={to} className="text-sm text-silver/70 hover:text-cyan transition-colors">{l}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-white font-head font-semibold text-sm tracking-wide mb-5">Hizmetler</h4>
            <ul className="space-y-3">
              {services.map(([l, to]) => (
                <li key={to}>
                  <Link to={to} className="text-sm text-silver/70 hover:text-cyan transition-colors">{l}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-white font-head font-semibold text-sm tracking-wide mb-5">İletişim</h4>
            <ul className="space-y-4 text-sm text-silver/70">
              {isReal(s?.company_phone) && <li className="flex gap-3"><Phone className="w-4 h-4 text-cyan shrink-0 mt-0.5" strokeWidth={1.5} /><a href={`tel:${s.company_phone.replace(/[^0-9+]/g, "")}`} className="hover:text-cyan transition-colors">{s.company_phone}</a></li>}
              {isReal(s?.company_email) && <li className="flex gap-3"><Mail className="w-4 h-4 text-cyan shrink-0 mt-0.5" strokeWidth={1.5} /><a href={`mailto:${s.company_email}`} className="hover:text-cyan transition-colors break-all">{s.company_email}</a></li>}
              {isReal(s?.company_address) && <li className="flex gap-3"><MapPin className="w-4 h-4 text-cyan shrink-0 mt-0.5" strokeWidth={1.5} /><span>{s.company_address}</span></li>}
            </ul>
            <Link to="/iletisim" className="mt-6 inline-flex items-center gap-2 text-cyan text-sm font-semibold group">
              Teklif Alın <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </Link>
          </div>
        </div>

        <div className="relative mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-silver/50">© {year} Sistem Elektrik ve Mühendislik. Tüm hakları saklıdır.</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs text-silver/50">
            <Link to="/kvkk-aydinlatma-metni" className="hover:text-cyan transition-colors">KVKK Aydınlatma Metni</Link>
            <Link to="/gizlilik-politikasi" className="hover:text-cyan transition-colors">Gizlilik Politikası</Link>
            <Link to="/cerez-politikasi" className="hover:text-cyan transition-colors">Çerez Politikası</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
